import DsChip, { type ChipProps } from '@carvana/ds-chip';
import cx from 'classnames';
import { useDeviceType } from '~/context/common/DeviceContext';
import { touchActiveClasses } from './Chip.styles';

type OwnProps = React.PropsWithChildren<ChipProps>;

export default function Chip({ children, ...props }: OwnProps) {
  const { className, ...rest } = props;
  const { isMobile, isTablet } = useDeviceType();

  return (
    <DsChip
      {...rest}
      className={cx(className, { [touchActiveClasses]: isMobile || isTablet })}
    >
      {children}
    </DsChip>
  );
}
